'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _identityInfo = require('../actions/identity-info');

var Actions = _interopRequireWildcard(_identityInfo);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var initialState = {
    me: null,
    isFetching: 0,
    isError: false,
    error: null,
    channelInfo: {
        isFetching: 0
    }
};

/*
 HELPERS
 */
function createNewMeObject(identity) {
    var newMe = {};

    identity.displayName ? newMe.displayName = identity.displayName : null;
    identity.entitlements ? newMe.entitlements = identity.entitlements : null;
    identity.id ? newMe.id = identity.id : null;
    identity.name ? newMe.name = identity.name : null;
    identity.timezone ? newMe.timezone = identity.timezone : null;
    identity.userName ? newMe.userName = identity.userName : null;
    identity.meta.created ? newMe.createdTime = identity.meta.created : null;

    return newMe;
}

function checkForEntitlements(me) {
    return me && me.entitlements && me.entitlements.includes('g2w');
}

exports.default = function () {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
    var action = arguments[1];

    switch (action.type) {
        case Actions.GET_USER_IDENTITY_START:
            {
                return _extends({}, state, {
                    me: null,
                    isFetching: state.isFetching + 1,
                    isError: false,
                    error: null
                });
            }

        case Actions.GET_USER_IDENTITY_COMPLETE:
            {
                var meObjComplete = createNewMeObject(action.identityInfo);
                var hasEntitlements = checkForEntitlements(meObjComplete);
                return _extends({}, state, {
                    me: meObjComplete,
                    hasEntitlements: hasEntitlements,
                    isFetching: state.isFetching - 1,
                    isError: false,
                    error: null
                });
            }

        case Actions.GET_USER_IDENTITY_FAILURE:
            {
                var errObjFailure = {};
                action.err && action.err.status ? errObjFailure.errCode = action.err.status : null;
                action.err && action.err.message ? errObjFailure.errorMessage = action.err.message : null;

                return _extends({}, state, {
                    me: null,
                    isFetching: state.isFetching - 1,
                    isError: true,
                    error: errObjFailure
                });
            }

        case Actions.GET_MY_CHANNEL_START:
            {
                return _extends({}, state, {
                    channelInfo: {
                        isFetching: state.isFetching + 1
                    }
                });
            }

        case Actions.GET_MY_CHANNEL_COMPLETE:
            {
                return _extends({}, state, {
                    channelInfo: {
                        organizerChannels: action.channels,
                        isFetching: state.isFetching - 1
                    }
                });
            }

        case Actions.GET_MY_CHANNEL_FAILURE:
            {
                return _extends({}, state, {
                    channelInfo: {
                        isFetching: state.isFetching - 1,
                        error: action.error
                    }
                });
            }

        default:
            return state;
    }
};


//////////////////
// WEBPACK FOOTER
// ./~/@getgo/webinar.com-frontend-redux/lib/shared/reducers/identity-info.js
// module id = 747
// module chunks = 0